module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/276.5c0e8adb.png";